import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PDFDocument } from 'pdf-lib'
import { FileHelper } from 'src/app/helpers';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-page-sample-letter-about-incorrect-credit-report-rw',
  templateUrl: './page-sample-letter-about-incorrect-credit-report-rw.component.html',
  styleUrls: ['./page-sample-letter-about-incorrect-credit-report-rw.component.css', '../module-page-rw/module-page-rw.component.css']
})
export class PageSampleLetterAboutIncorrectCreditReportRwComponent implements OnInit {

  @Input()
  backTitle = 'Back';

  @Input()
  nextTitle = 'Next';

  @Input()
  delay = true;

  @Output()
  back = new EventEmitter<Event>();

  @Output()
  next = new EventEmitter<Event>();

  content = {
    downloaded: false,
    validate:   false,
  };

  sampleCreditLetter: string = "../../../../../assets/sampleCreditLetter.pdf";
  letterHandout!: PDFDocument;

  previewByAdmin = this.auth.isSuperAdmin;
  // previewByAdmin = false;

  constructor(private auth: AuthService) { }

  async ngOnInit(): Promise<void> {
    const letterBytes = await fetch(this.sampleCreditLetter).then(res => res.arrayBuffer());
    this.letterHandout = await PDFDocument.load(letterBytes);
  }

  goBack(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.back.emit(event);
    return true;
  }

  goNext(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.next.emit(event);
    return true;
  }

  async downloadLetter() {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.letterHandout.save();
    FileHelper.saveByteArray('sampleCreditLetter.pdf', pdfBytes, 'application/pdf');
  }
}
